(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-knl-product]').forEach((root) => {
      if (root.dataset.knlInitialized) return;
      root.dataset.knlInitialized = 'true';
      const own = (selector) => Array.from(root.querySelectorAll(selector)).filter(el => el.closest('[data-knl-product]') === root);
      const source = own('[data-knl-json]')[0];
      if (!source) return;
      let data;
      try { data = JSON.parse(source.textContent); } catch (_) { return; }
      const variants = data.variants || [];
      const format = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:root.dataset.currency || 'USD'}).format(value / 100);
      const update = (id) => {
        const variant = variants.find(v => String(v.id) === String(id));
        if (!variant) return;
        own('input[name="id"]').forEach(input => { input.value = variant.id; });
        own('[data-knl-price]').forEach(el => { el.textContent = format(variant.price); });
        own('[data-knl-compare]').forEach(el => { el.textContent = variant.compare_at_price > variant.price ? format(variant.compare_at_price) : ''; });
        own('[data-knl-add]').forEach(button => {
          button.disabled = !variant.available;
          button.textContent = variant.available ? button.dataset.availableLabel : button.dataset.soldLabel;
        });
        if (variant.featured_image && variant.featured_image.src) own('[data-knl-main-image]').forEach(img => { img.src = variant.featured_image.src; img.removeAttribute('srcset'); });
      };
      own('[data-knl-variant]').forEach(select => select.addEventListener('change', () => update(select.value)));
      own('[data-knl-image]').forEach(button => button.addEventListener('click', () => {
        own('[data-knl-main-image]').forEach(img => { img.src = button.dataset.knlImage; img.removeAttribute('srcset'); });
        own('[data-knl-image]').forEach(el => el.setAttribute('aria-pressed', el === button ? 'true' : 'false'));
      }));
      const initial = own('[data-knl-variant]')[0] || own('input[name="id"]')[0];
      if (initial) update(initial.value);
    });
    scope.querySelectorAll('[data-knl-slider]').forEach(root => {
      if (root.dataset.knlInitialized) return;
      root.dataset.knlInitialized='true';
      const slides = Array.from(root.querySelectorAll('.knl-sld-item'));
      if (!slides.length) return;
      let index=0;
      const change = step => {
        index=(index+step+slides.length)%slides.length;
        slides.forEach((slide,i) => {slide.classList.toggle('knl-sld-active',i===index);slide.setAttribute('aria-hidden',i===index?'false':'true');});
      };
      root.querySelectorAll('.knl-sld-left,.knl-sld-right').forEach(control => {
        control.setAttribute('role','button');control.setAttribute('tabindex','0');
        const step=control.classList.contains('knl-sld-left')?-1:1;
        control.setAttribute('aria-label',step<0?'Previous slide':'Next slide');
        control.addEventListener('click',()=>change(step));
        control.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();change(step);}});
      });
      change(0);
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
